import React from 'react';
import { Accordion } from 'flowbite-react';
import Image from 'next/image';

const AgricultureKeyFocus = () => {
    return (
        <div className="section-py bg-grey">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12 pb-30">
                    <div className="lg:col-span-12">
                        <p
                            className="text-[#00B050] mb-2.5 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Key Focus Areas to Consider
                        </p>
                        <h2 className="mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Our Expertise in Custom Agriculture Software Development
                        </h2>
                    </div>
                </div>
                <div className="row items-center grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <Accordion>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Autonomous Farming Management Systems
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        We build software that supports self-driving tractors, automated seeding, and equipment
                                        coordination, boosting efficiency while reducing labor dependence.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Farm Inventory Management
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        Track seeds, fertilizers, machinery, and outputs in real time. Our solutions help reduce
                                        waste, prevent stockouts, and ensure supply chain visibility.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Soil-Mapping Software Integrations
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        Integrate GIS data, drone imagery, and soil test reports into intuitive visual maps;
                                        empowering better decisions for planting, fertilization, and irrigation.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Farm Monitoring System Development
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        Monitor crop conditions, equipment status, and environmental variables remotely with
                                        centralized dashboards and alert-based notifications.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Agronomy Software Solutions
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        From crop planning to nutrient scheduling, we build tools that help agronomists optimize
                                        yields, reduce inputs, and adapt to changing field conditions.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Agriculture Precision Farming Apps
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        Enable real-time decisions on spraying, fertilizing, and harvesting using location-based
                                        intelligence, AI models, and IoT integration
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Autonomous Harvesting Solutions
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        Leverage robotics and machine vision to automate harvesting for specific crop types—
                                        ensuring consistency, speed, and reduced post-harvest losses.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Smart Irrigation System Management
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        Develop systems that monitor soil moisture, weather forecasts, and plant health to deliver
                                        water precisely where and when it&apos;s needed.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                        </Accordion>
                    </div>
                    <div className="lg:col-span-6 text-center">
                        <Image
                            src="/img/agriculture-industry/svg/vector-our-expertise.svg"
                            alt="key-focus-area"
                            title="key-focus-area"
                            className="img-fluid"
                            height={468}
                            width={595}
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AgricultureKeyFocus;
